export default e=>e.replace(/[-_][a-z\u00E0-\u00F6\u00F8-\u00FE]/g,e=>e.slice(1).toUpperCase());
